<?xml version="1.0" encoding="iso-8859-1"?>
<!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
<svg
  version="1.1"
  id="Layer_1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 503.467 503.467"
  xml:space="preserve"
>
  <g transform="translate(6 3)">
    <path
      fill="#aab1ba"
      d="M356.667,154.19v34.133c-16.213,0-34.133-1.707-34.133-1.707
		C261.947,178.083,210.747,138.83,186,85.07c0,0-8.533-18.773-8.533-41.813l25.6-25.6c0,0,17.067,68.267,51.2,102.4
		S356.667,154.19,356.667,154.19"
    />
    <path
      fill="#ff7474"
      d="M407.867,376.057h17.067c39.253,0,68.267,29.867,68.267,68.267H339.6L58,162.723L177.467,43.257
		c0,23.04,8.533,41.813,8.533,41.813c24.747,53.76,75.947,93.013,136.533,101.547c0,0,17.92,1.707,34.133,1.707v136.533
		L407.867,376.057z"
    />
    <path
      fill="#ffe079"
      d="M321.68,239.523c0,4.267-3.413,8.533-8.533,8.533s-8.533-4.267-8.533-8.533s3.413-8.533,8.533-8.533
		S321.68,235.257,321.68,239.523z M313.147,316.323c-5.12,0-8.533-4.267-8.533-8.533s3.413-8.533,8.533-8.533
		s8.533,4.267,8.533,8.533S318.267,316.323,313.147,316.323z"
    />
    <path
      fill="#ecf4f7"
      d="M493.2,444.323v17.067c0,10.24-7.68,17.067-17.067,17.067H336.187
		c-13.653,0-22.187-8.533-22.187-8.533L46.907,202.83c-7.68-7.68-7.68-21.333-0.853-28.16L58,162.724l281.6,281.6L493.2,444.323
		L493.2,444.323z"
    />
  </g>
  <path
    fill="#51565f"
    d="M482.133,485.723h-140.8c-14.507,0-24.747-9.387-24.747-9.387L49.493,209.243
	c-4.267-4.267-6.827-11.093-7.68-17.067c0-6.827,2.56-12.8,6.827-17.067l11.093-11.093l0,0l0,0L204.8,18.95
	c0.853-0.853,2.56-1.707,4.267-0.853c1.707,0,2.56,1.707,3.413,3.413c0,0.853,17.067,67.413,50.347,100.693
	c32.427,32.427,98.987,33.28,98.987,33.28c2.56,0,4.267,1.707,4.267,4.267v168.96l16.213,16.213c1.707,1.707,1.707,4.267,0,5.973
	c-1.707,1.707-4.267,1.707-5.973,0l-17.067-17.067c-0.853-0.853-0.853-1.707-0.853-3.413v-12.8h-27.307
	c-1.707,5.12-6.827,8.533-11.947,8.533c-6.827,0-12.8-5.973-12.8-12.8s5.973-12.8,12.8-12.8c5.973,0,10.24,3.413,11.947,8.533H358.4
	V249.35h-27.307c-1.707,5.12-6.827,8.533-11.947,8.533c-6.827,0-12.8-5.973-12.8-12.8c0-6.827,5.973-12.8,12.8-12.8
	c5.973,0,10.24,3.413,11.947,8.533H358.4v-76.8c-16.213-0.853-70.827-5.12-101.547-34.987c-28.16-28.16-45.227-78.507-50.347-97.28
	L69.973,168.283l277.333,277.333h147.627c-1.707-34.133-29.013-59.733-64-59.733h-51.2c-2.56,0-4.267-1.707-4.267-4.267
	s1.707-4.267,4.267-4.267h51.2c40.96,0,72.533,31.573,72.533,72.533v17.067C503.467,476.337,494.08,485.723,482.133,485.723z
	 M64,171.697l-8.533,8.533c-2.56,2.56-4.267,6.827-4.267,11.093c0,4.267,1.707,8.533,5.12,11.093L323.413,469.51
	c0,0,7.68,7.68,18.773,7.68h140.8c7.68,0,12.8-5.12,12.8-12.8v-12.8H345.6c-0.853,0-2.56-0.853-3.413-0.853L64,171.697z
	 M319.147,306.523c-2.56,0-4.267,1.707-4.267,4.267s1.707,4.267,4.267,4.267s4.267-1.707,4.267-4.267
	S321.707,306.523,319.147,306.523z M319.147,238.257c-2.56,0-4.267,1.707-4.267,4.267c0,2.56,1.707,4.267,4.267,4.267
	s4.267-1.707,4.267-4.267C323.413,239.964,321.707,238.257,319.147,238.257z M192,417.457H38.4c-2.56,0-4.267-1.707-4.267-4.267
	c0-2.56,1.707-4.267,4.267-4.267H192c2.56,0,4.267,1.707,4.267,4.267C196.267,415.75,194.56,417.457,192,417.457z M140.8,366.257
	H4.267c-2.56,0-4.267-1.707-4.267-4.267s1.707-4.267,4.267-4.267H140.8c2.56,0,4.267,1.707,4.267,4.267
	S143.36,366.257,140.8,366.257z M277.333,332.123c-2.56,0-4.267-1.707-4.267-4.267v-102.4c0-2.56,1.707-4.267,4.267-4.267
	s4.267,1.707,4.267,4.267v102.4C281.6,330.417,279.893,332.123,277.333,332.123z M89.6,315.057H21.333
	c-2.56,0-4.267-1.707-4.267-4.267s1.707-4.267,4.267-4.267H89.6c2.56,0,4.267,1.707,4.267,4.267S92.16,315.057,89.6,315.057z
	 M328.533,193.883C328.533,193.883,327.68,193.883,328.533,193.883c-62.293-8.533-114.347-47.787-140.8-104.107
	c-0.853-2.56,0-4.267,1.707-5.973c2.56-0.853,4.267,0,5.973,1.707c24.747,53.76,75.093,90.453,133.12,98.987
	c2.56,0,4.267,2.56,3.413,5.12C331.947,192.177,330.24,193.883,328.533,193.883z"
  />
</svg>
